import React from 'react';
import { Container } from 'react-bootstrap';
import { Layout } from '../../components/layout';

export const ShareTransferArticle: React.FC = () => {
  return (
    <Layout title="INFORMATION" subtitle="お知らせ">
      <Container className="my-5">
        <h1>株式譲渡のお知らせ</h1>
        <p><small>2020-04-30</small></p>
        <p>
          株式会社エムケイシステムは新明工業株式会社に全株式を譲渡しグループ会社となることを決定し、合意に至りましたことをお知らせいたします。
        </p>
        <table>
          <tbody>
            <tr>
              <td style={{  padding: '8px', verticalAlign: 'top', whiteSpace: 'nowrap' }}>2020.04.30</td>
              <td style={{  padding: '8px', verticalAlign: 'top' }}>弊社全株式を新明工業株式会社に譲渡しグループ会社となる</td>
            </tr>
            <tr>
              <td rowSpan={4} style={{  padding: '8px', verticalAlign: 'top', whiteSpace: 'nowrap' }}>2020.05.01</td>
              <td style={{  padding: '8px', verticalAlign: 'top' }}>代表取締役会長に近藤恭弘が就任</td>
            </tr>
            <tr><td style={{  padding: '8px', verticalAlign: 'top' }}>代表取締役社長に山本寿彦が就任</td></tr>
            <tr><td style={{  padding: '8px', verticalAlign: 'top' }}>専務取締役に清水克祐が留任</td></tr>
            <tr><td style={{  padding: '8px', verticalAlign: 'top' }}>顧問に木下光男が就任</td></tr>
          </tbody>
        </table>
      </Container>
    </Layout>
  );
};
